import { ExternalCalendarEvent } from '@griply/types';
import { format } from 'date-fns';

import { getCalendarEventReferenceDate } from './get-calendar-event-reference-date';
import { isExternalEventAllDay } from './is-external-event-all-day';

export type ExternalEventTimeLabel =
  | { isAllDay: true }
  | { isAllDay: false; range: string };

// A timed event spanning midnight stays timed rather than widening into the all-day row.
export const getExternalEventTimeLabel = (
  event: ExternalCalendarEvent,
  timeFormat: string,
): ExternalEventTimeLabel => {
  if (isExternalEventAllDay(event)) {
    return { isAllDay: true };
  }

  const fallback = new Date(0);
  const start = getCalendarEventReferenceDate(event.start, fallback);
  const end = getCalendarEventReferenceDate(event.end, fallback);

  return {
    isAllDay: false,
    range: `${format(start, timeFormat)}-${format(end, timeFormat)}`,
  };
};
